var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiperBox",on:{"mouseenter":_vm.mouseenter,"mouseleave":_vm.mouseleave}},[_c('div',{attrs:{"id":"swiper"}},[_c('div',{staticClass:"imgBox"},_vm._l((_vm.imgList),function(item,index){return _c('div',{key:index,staticClass:"imgDiv"},[_c('img',{style:('width:' + _vm.imgWidth + 'px;'),attrs:{"src":item}})])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }